import InputTextField from './inputTextField.component';

export default InputTextField;
